export * from './terroristList.component';
export * from './terroristFile.component';
export * from './terroristView.component';

